import { useEffect, useRef, useState } from "react";

export function useComponentWidth<T extends HTMLElement>() {
  const containerRef = useRef<T | null>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (containerRef.current) {
        requestAnimationFrame(() => {
          setWidth(containerRef.current!.offsetWidth);
        });
      }
    });

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return { containerRef, width };
}
